<template>
  <div>
    <p class="desc">选择能发起该审批的人员/部门，不选则默认开放给所有人</p>
    <el-button size="mini" @click="selectMember" icon="el-icon-plus" type="primary" round>请选择</el-button>
    <member-items v-model="select"/>
    <member-picker title="请选择可发起本审批的人员/部门" multiple ref="memberPicker" :selected="select" @ok="selected"/>
  </div>
</template>

<script>
import MemberPicker from '../../common/MemberPicker'
import MemberItems from '../MemberItems'

export default {
  name: 'RootConfig',
  components: {MemberPicker, MemberItems},
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      showMemberSelect: false
    }
  },
  computed: {
    select: {
      get () {
        return this.config.assignedUser || []
      },
      set (val) {
        this.config.assignedUser = val
      }
    }
  },
  methods: {
    selectMember () {
      this.$refs.memberPicker.show()
    },
    selected (select) {
      this.select.length = 0
      select.forEach(val => this.select.push(val))
    },
    removeMemberItem (index) {
      this.select.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.desc{
  font-size: small;
  color: #8c8c8c;
}
.member-item{
  margin: 5px;
}
</style>
